import React, { useState } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { selectIssueOption, Select } from '@atlassian/jira-portfolio-3-common/src/select/index.tsx';
import type { Issue } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/issues/types.tsx';
import { getBody } from '@atlassian/jira-portfolio-3-portfolio/src/common/dom/index.tsx';
import messages from './messages.tsx';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types.tsx';

type Option = Issue & {
	label?: string;
};

const IssueSelector = ({
	issueTypes,
	onChangeDependencyIssue,
	projectsById,
	issues,
	otherIssue,
	value,
	testId,
	ariaLabel,
}: Props) => {
	const { formatMessage } = useIntl();
	const [query, setQuery] = useState('');

	const getDependencyIssueValue = ({ issueKey, project: projectId, summary }: Issue) => {
		const project = projectsById[projectId || NaN];
		const key = issueKey ? `${project.key}-${issueKey}` : project.key;
		return `${key} ${summary}`;
	};
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const renderDependencyIssue = (issue: any) => {
		const issueType = issueTypes.find(({ id }) => id === issue.type);
		return selectIssueOption({
			icon: issueType && issueType.iconUrl,
			label: getDependencyIssueValue(issue),
		});
	};

	// eslint-disable-next-line @typescript-eslint/no-shadow
	const options: Option[] = issues.reduce<Option[]>((options, issue) => {
		if (
			options.length < 50 &&
			getDependencyIssueValue(issue).toLowerCase().includes(query) &&
			(!otherIssue || issue.id !== otherIssue.id)
		) {
			options.push({
				...issue,
				label: getDependencyIssueValue(issue),
			});
		}
		return options;
	}, []);

	const handleInputChange = (q: string) => {
		setQuery(q.toLowerCase());
	};

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		<div className={styles.addDependencyIssueSelector} data-testid={testId}>
			<Select
				options={options}
				onChange={onChangeDependencyIssue}
				value={value}
				menuPortalTarget={getBody()}
				styles={{
					// eslint-disable-next-line @typescript-eslint/no-shadow
					menuPortal: (styles) => ({
						...styles,
						zIndex: 1000,
					}),
				}}
				isTransparentBackground={false}
				placeholder={formatMessage(messages.issueSelectorPlaceholder)}
				formatOptionLabel={renderDependencyIssue}
				onInputChange={handleInputChange}
				getOptionValue={getDependencyIssueValue}
				aria-label={ariaLabel}
			/>
		</div>
	);
};

export default IssueSelector;
